import React from 'react'
import { connect } from 'react-redux'
import { ToDoList } from 'components/Layout'
import { BoxShell } from 'components/Shells'

import includes from 'lodash/includes'

class ToDoListContainer extends React.Component {
	appSubPath(path) {
		return '/apps/' + this.props.appId + '/' + path
	}

	render() {
		const {
			app,
			isAppInstalledForTeam,
			isDisplayCompleted,
			isFeaturesCompleted,
			// isAppInReview,
			// isAppPublished,
			withoutInstall,
			header,
			footer
		} = this.props

		if (typeof app === 'undefined') {
			return <BoxShell height={150} />
		}

		const todos = withoutInstall
			? [
					{
						id: 'display-setup',
						title: 'Finish display setup',
						desc: 'Give your app some basic look!',
						path: this.appSubPath('display'),
						completed: isDisplayCompleted
					},
					{
						id: 'features-setup',
						title: 'Configure features',
						desc: 'Set up the features your app will use.',
						path: this.appSubPath('features'),
						completed: isFeaturesCompleted
					}
				]
			: [
					{
						id: 'display-setup',
						title: 'Finish display setup',
						desc: 'Give your app some basic look!',
						path: this.appSubPath('display'),
						completed: isDisplayCompleted
					},
					{
						id: 'features-setup',
						title: 'Configure features',
						desc: 'Set up the features your app will use.',
						path: this.appSubPath('features'),
						completed: isFeaturesCompleted
					},
					{
						id: 'private-app-installation',
						title: 'Install app on your license',
						desc: 'Get your app up and running.',
						path: this.appSubPath('distribution'),
						completed: isAppInstalledForTeam
					}
				]
		//					{
		//						id: 'app-review',
		//						title: 'Submit app to a review',
		//						desc: 'Let us know if your app is ready for a review!',
		//						path: this.appSubPath('distribution'),
		//						completed: isAppInReview || isAppPublished
		//					},
		//					{
		//
		//						id: 'publish',
		//						title: 'Publish your app',
		//						desc:
		//							'If the review goes smoothly, make your app public.',
		//						path: this.appSubPath('distribution'),
		//						completed: isAppPublished
		//					}]

		return <ToDoList header={header} footer={footer} todos={todos} />
	}
}

const mapStateToProps = (state, ownProps) => {
	const currentAppId = ownProps.appId
	const currentApp = state.apps.items[currentAppId]

	const isDisplayCompleted =
		typeof currentApp !== 'undefined'
			? currentApp.shortDescription && currentApp.description
			: false

	const isAppInReview =
		typeof currentApp !== 'undefined'
			? currentApp.status === 'IN_REVIEW'
			: false

	const isAppPublished =
		typeof currentApp !== 'undefined'
			? currentApp.status === 'PUBLISHED'
			: false

	const extUrl = currentApp ? currentApp.customData.url : false

	const isFeaturesCompleted =
		typeof currentApp !== 'undefined' ? extUrl : false

	const isAppInstalledForTeam = includes(
		state.installedApps.items,
		currentAppId
	)

	return {
		app: currentApp,
		isDisplayCompleted,
		isFeaturesCompleted,
		isAppPublished,
		isAppInstalledForTeam,
		isAppInReview
	}
}

const mapDispatchToProps = (dispatch, ownProps) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ToDoListContainer)



// WEBPACK FOOTER //
// ./src/containers/ToDoList/ToDoList.js